// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type {
    PostInspectionPointsSaveInspectonRuleBody,
    BaseResponseInspectionPointFoundResponse,
} from '../../types';

/**
 * saveInspectonRule
 *
 * @export
 * @tags 质检点
 * @link [POST] /inspectionPoints/saveInspectonRule
 */
export function postInspectionPointsSaveInspectonRule(
    data: PostInspectionPointsSaveInspectonRuleBody
): Promise<BaseResponseInspectionPointFoundResponse>;
export function postInspectionPointsSaveInspectonRule(
    data: PostInspectionPointsSaveInspectonRuleBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseInspectionPointFoundResponse>;
export function postInspectionPointsSaveInspectonRule(
    data: PostInspectionPointsSaveInspectonRuleBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseInspectionPointFoundResponse> {
    return request<PostInspectionPointsSaveInspectonRuleBody, never, never>(
        '/inspectionPoints/saveInspectionRule',
        {
            ...options,
            data,
            method: 'post',
            __$requestCalleeName: 'postInspectionPointsSaveInspectonRule',
        }
    );
}

export const meta = [
    { tags: ['质检点'], path: '/inspectionPoints/saveInspectonRule', method: 'post' },
];
